import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Sigma, Atom } from "lucide-react";

export const SUBJECTS = {
  matematicas: { key: "matematicas", name: "Matemáticas", icon: Sigma, blurb: "Álgebra, cálculo, geometría y más, explicado paso a paso.", cover: "https://images.unsplash.com/photo-1635372722656-389f87a941b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" },
  fisica: { key: "fisica", name: "Física", icon: Atom, blurb: "Mecánica, ondas, electromagnetismo y el cosmos.", cover: "/fisica-cover.webp" },
};

export const HERO_IMG = "https://images.unsplash.com/photo-1502134249126-9f3755a50d78?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400";

export default function Aprende() {
  return (
    <div>
      <section className="relative overflow-hidden bg-nasa-navy">
        <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-55" />
        <div className="absolute inset-0 bg-gradient-to-r from-nasa-navy via-nasa-navy/80 to-nasa-navy/30" />
        <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pt-36 pb-20">
          <div className="flex items-center gap-3 mb-6"><span className="eyebrow text-white/90">SECCIÓN · APRENDE</span></div>
          <h1 className="font-hero font-extrabold tracking-tight text-5xl sm:text-6xl lg:text-7xl leading-[1.05] text-white">Elige tu disciplina</h1>
          <p className="mt-7 text-lg lg:text-xl text-white/85 max-w-2xl leading-relaxed">Cada apartado incluye explicaciones, vídeos, experimentos, diapositivas y una zona de práctica con soluciones.</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-7">
          {Object.values(SUBJECTS).map((s, i) => (
            <motion.div key={s.key} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}>
              <Link
                to={`/aprende/${s.key}`}
                data-testid={`subject-card-${s.key}`}
                className="group relative block h-80 overflow-hidden border border-paper-200 hover:border-nasa-blue transition-colors"
              >
                <img src={s.cover} alt={s.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-nasa-navy via-nasa-navy/55 to-transparent" />
                <div className="relative z-20 h-full flex flex-col justify-end p-8 text-white">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full mb-4 bg-white text-nasa-blue"><s.icon size={24} /></span>
                  <h2 className="font-display font-extrabold text-3xl">{s.name}</h2>
                  <p className="text-white/85 mt-2">{s.blurb}</p>
                  <span className="inline-flex items-center gap-1.5 mt-4 text-sm font-bold text-white group-hover:gap-2.5 transition-all">Ver apartados <ArrowRight size={15} /></span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
